/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withState, withHandlers, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { analytics } from 'services/Analytics'
import { ERROR_CODES } from 'constants/errors'
import { EMPTY_ARRAY } from 'constants/frozenObjects'
import { withLocalization } from 'hocs/localization'
import { formWithCaptcha } from 'hocs/formWithCaptcha'
import { onShowError, createAlert } from 'redux-app/modules/alerts'
import { ALERTS } from 'constants/alerts'
import { onSignUp } from 'redux-app/modules/auth'
import { isCaptchaEnabled , isCaptchaWhiteListed } from 'redux-app/selectors/apiData'
import { getSelectedPlanId } from 'redux-app/selectors/subscription'
import { getErrorCodes, getFormErrorMessages } from 'utils/error'
import { STEPS } from './constants'
import SignUpForm from './SignUpForm'

export default compose(
  connect(
    state => ({
      subscriptionPlanId: getSelectedPlanId(state),
      isCaptchaEnabled: isCaptchaEnabled(state),
      isCaptchaWhiteListed: isCaptchaWhiteListed(state),
    }),
    {
      onSignUp,
      onShowError,
      createAlert,
    },
  ),
  withState('step', 'onUpdateStep', STEPS.form),
  withState('errorMessages', 'onSetErrorMessages', EMPTY_ARRAY),
  withState('showConfirmationMessage', 'onShowConfirmationMessage', false),
  withLocalization('auth.signUp.form'),
  withHandlers({
    onSubmit: ({ onSignUp, onUpdateStep, onShowError, onSetErrorMessages, createAlert,
      t, isCaptchaEnabled, isCaptchaWhiteListed, onShowConfirmationMessage }) => formValues => {
        onSetErrorMessages(EMPTY_ARRAY)
        onShowConfirmationMessage(false)
        if (isCaptchaEnabled && !isCaptchaWhiteListed && !formValues.captcha) {
          return Promise.resolve()
        }
        return onSignUp(formValues)
        .then(() => {
          onUpdateStep(STEPS.success)
          createAlert({ name: ALERTS.signUpSuccesfull })
          onShowConfirmationMessage(true)
        })
        .catch(error => {
          analytics.showSignUpError({ errorCodes: getErrorCodes(error) })
          if (getErrorCodes(error).includes(ERROR_CODES.userAlreadyExist)) {
            onSetErrorMessages(getFormErrorMessages(error, t))
            return
          }
          onShowError(error)
        })
      },
  }),
  reduxForm({
    form: 'signUp',
  }),
  lifecycle({
    componentDidMount () {
      analytics.openSignUpPage()
    },
  }),
  formWithCaptcha,
)(SignUpForm)
